'use strict';

goog.provide("Ntry.Entity");

goog.require("Ntry.Utils");

Ntry.Entity = function(index) {
    this.id = Ntry.Utils.generateHash();

    this.components = {};

    this.timeStamp = new Date().getTime();

    this.index = index;
}

